// extracted by mini-css-extract-plugin
export default {"controls":"DescriptionEdit_controls__nl6W5","field":"DescriptionEdit_field__UOI7T"};